import { listFileHistory, remove, uploadFile } from './calls';

export default class UploadFileCaller {
  static uploadFile = async (params: any) => {
    const { data: result } = await uploadFile(params);
    return result;
  };

  static loadFileHistory = async (params: any) => {
    const {
      data: { archives },
    } = await listFileHistory(params);

    return archives;
  };

  static delete = async (id: string) => {
    const { data } = await remove(id);

    return data;
  };
}
